// Dependencies
import axios, { AxiosRequestConfig } from "axios";

// Utils
import apiErrorHandling from "./errorHandling";

const headers = {
    headers: {
        "Content-Type": "application/json",
        "X-Platform": "web"
    }
};

const baseURL = process.env.REACT_APP_RAIZ_API_URL;

const config: AxiosRequestConfig = {
    baseURL,
    headers: headers.headers
};

const raizApi = axios.create(config);
raizApi.interceptors.response.use(
    (response) => response,
    async (error) => apiErrorHandling(error)
);

export { raizApi, config, headers, baseURL };
